export default {
  configs_pending: false,
  configs: []
}
